'use strict';

(function() {
  if (window.__asLaunchGiftPurchaseBound) return;
  window.__asLaunchGiftPurchaseBound = true;

  function getSecondaryGiftVariantId(bundle) {
    var variantIds = [];
    try {
      variantIds = JSON.parse(bundle.dataset.secondaryGiftVariantIds || '[]');
    } catch (error) {
      variantIds = [];
    }

    variantIds = variantIds.map(String).filter(Boolean);
    if (!variantIds.length) return '';

    var selectedVariantId = bundle.dataset.selectedSecondaryGiftVariantId || '';
    if (variantIds.indexOf(selectedVariantId) === -1) {
      selectedVariantId = variantIds[0];
      bundle.dataset.selectedSecondaryGiftVariantId = selectedVariantId;
    }

    return selectedVariantId;
  }

  function getLaunchGiftConfig() {
    var bundle = document.querySelector('[data-launch-gift-bundle]');
    if (!bundle) return null;

    var primaryGiftVariantId = bundle.dataset.giftVariantId || '';
    var secondaryGiftRequired = bundle.dataset.secondaryGiftRequired === 'true';
    var secondaryGiftVariantId = getSecondaryGiftVariantId(bundle);
    var giftVariantIds = [primaryGiftVariantId];
    if (secondaryGiftVariantId) giftVariantIds.push(secondaryGiftVariantId);

    return {
      bundle: bundle,
      giftVariantIds: giftVariantIds.filter(Boolean),
      giftAvailable:
        bundle.dataset.giftAvailable === 'true' &&
        (!secondaryGiftRequired ||
          (bundle.dataset.secondaryGiftAvailable === 'true' && Boolean(secondaryGiftVariantId))),
      startsAt: Date.parse(bundle.dataset.campaignStartAt || ''),
      endsAt: Date.parse(bundle.dataset.campaignEndAt || '')
    };
  }

  function isLaunchGiftActive(config) {
    if (!config || !config.giftVariantIds.length || !config.giftAvailable) return false;
    if (!Number.isFinite(config.startsAt) || !Number.isFinite(config.endsAt)) return false;

    var now = Date.now();
    return now >= config.startsAt && now <= config.endsAt;
  }

  function syncLaunchGiftBundleState() {
    var config = getLaunchGiftConfig();
    if (!config) return;

    var now = Date.now();
    var campaignEnded = Number.isFinite(config.endsAt) && now > config.endsAt;
    var soldOutDuringCampaign =
      Number.isFinite(config.startsAt) &&
      Number.isFinite(config.endsAt) &&
      now >= config.startsAt &&
      now <= config.endsAt &&
      !config.giftAvailable;

    config.bundle.hidden = campaignEnded || soldOutDuringCampaign;
  }

  function syncLaunchGiftPurchaseButtons() {
    if (document.querySelector('[data-style-purchase]')) {
      syncStylePurchase();
      return;
    }
    var variantSelect = document.querySelector('.as-product-variant');
    var variantsData = document.querySelector('.as-variants-data');
    if (!variantSelect || !variantsData) return;

    var variants = [];
    try {
      variants = JSON.parse(variantsData.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    var variant = variants.find(function(item) {
      return String(item.id) === String(variantSelect.value);
    });
    if (!variant) return;

    var quantityInput = document.querySelector('.as-form-control-number');
    var quantity = Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1);
    var config = getLaunchGiftConfig();

    document.querySelectorAll('.as-unified-variant-id').forEach(function(input) {
      input.value = variant.id;
    });
    document.querySelectorAll('.as-unified-quantity').forEach(function(input) {
      input.value = String(quantity);
    });
    document.querySelectorAll('.as-unified-shop-pay-editor-link').forEach(function(link) {
      var cartUrl = link.dataset.cartUrl || '/cart';
      var checkoutItems = [variant.id + ':' + quantity];
      if (isLaunchGiftActive(config)) {
        config.giftVariantIds.forEach(function(giftVariantId) {
          checkoutItems.push(giftVariantId + ':' + quantity);
        });
      }
      link.href = cartUrl + '/' + checkoutItems.join(',');
    });
  }

  function prepareProductFormUi(productForm, form) {
    var addButton = form.querySelector('button[type="submit"]');
    productForm.$addToCart = addButton;
    productForm.$errorMessageWrapper = form.querySelector('.as-product-form__error-message-wrapper');
    productForm.$errorMessage = form.querySelector('.as-product-form__error-message');
  }

  // Style owns both links, including buttons replaced by the variant section response.
  // Observe only child replacements inside its purchase wrappers, never attributes.
  function syncStylePurchase() {
    var wraps = document.querySelectorAll('[data-style-purchase]');
    if (!wraps.length) return;
    var select = document.querySelector('.as-product-variant');
    var data = document.querySelector('.as-variants-data');
    var variants;
    try { variants = JSON.parse(data ? data.textContent : '[]'); } catch (error) { variants = []; }
    var variant = Array.isArray(variants) && variants.find(function(item) {
      return select && String(item.id) === select.value && /^[1-9]\d*$/.test(String(item.id));
    });
    var input = document.querySelector('.as-form-control-number');
    var quantity = Number(input && input.value || 1);
    var valid = variant && variant.available && Number.isSafeInteger(quantity) && quantity > 0;
    var config = getLaunchGiftConfig();
    var items = [];
    function appendItem(id, count) {
      id = String(id || '');
      if (!/^[1-9]\d*$/.test(id) || items.some(function(item) { return item.id === id; })) return;
      items.push({ id: id, quantity: count });
    }
    if (valid) {
      appendItem(variant.id, quantity);
      if (isLaunchGiftActive(config)) {
        config.giftVariantIds.forEach(function(id) { appendItem(id, quantity); });
      }
      document.querySelectorAll('.as-recommendations-btn.picked, .as-item-accessories.active').forEach(function(item) {
        appendItem(item.dataset.variantid || item.dataset.id, 1);
      });
    }
    wraps.forEach(function(wrap) {
      if (valid) {
        wrap.querySelectorAll('.as-unified-variant-id').forEach(function(field) { field.value = variant.id; });
        wrap.querySelectorAll('.as-unified-quantity').forEach(function(field) { field.value = quantity; });
      }
      wrap.querySelectorAll('.as-unified-shop-pay-editor-link').forEach(function(link) {
        if (!valid) {
          link.removeAttribute('href');
          link.setAttribute('aria-disabled', 'true');
          return;
        }
        var cart = new URL('/cart', window.location.origin);
        try {
          var candidate = new URL(link.dataset.cartUrl || '/cart', window.location.origin);
          if (candidate.origin === window.location.origin && /\/(?:[a-zA-Z-]+\/)?cart\/?$/.test(candidate.pathname) && !candidate.username && !candidate.password) cart = candidate;
        } catch (error) { /* Use the same-origin cart fallback. */ }
        cart.search = '';
        cart.hash = '';
        cart.pathname = cart.pathname.replace(/\/$/, '') + '/' + items.map(function(item) {
          return item.id + ':' + item.quantity;
        }).join(',');
        link.href = cart.href;
        link.removeAttribute('aria-disabled');
      });
    });
  }

  var styleSyncPending = false;
  function scheduleStyleSync() {
    if (styleSyncPending || !document.querySelector('[data-style-purchase]')) return;
    styleSyncPending = true;
    Promise.resolve().then(function() { styleSyncPending = false; syncStylePurchase(); });
  }
  var styleObserved = new WeakSet();
  function bindStylePurchase() {
    document.querySelectorAll('[data-style-purchase]').forEach(function(wrap) {
      if (styleObserved.has(wrap)) return;
      styleObserved.add(wrap);
      new MutationObserver(scheduleStyleSync).observe(wrap, { childList: true, subtree: true });
    });
    syncStylePurchase();
  }
  window.__asSyncStylePurchase = syncStylePurchase;
  document.addEventListener('change', function(event) {
    if (event.target.matches('.as-product-variant, .as-form-control-number')) scheduleStyleSync();
  }, true); // The legacy variant control emits a non-bubbling change event.
  document.addEventListener('input', function(event) {
    if (event.target.matches('.as-form-control-number')) scheduleStyleSync();
  }, true);
  document.addEventListener('change.accessories', scheduleStyleSync);
  function prepareStyleLink(event) {
    var link = event.target.closest && event.target.closest('[data-style-purchase] .as-unified-shop-pay-editor-link');
    if (!link) return;
    syncStylePurchase();
    if (link.getAttribute('aria-disabled') === 'true') event.preventDefault();
  }
  document.addEventListener('click', prepareStyleLink, true);
  document.addEventListener('auxclick', prepareStyleLink, true);
  document.addEventListener('contextmenu', prepareStyleLink, true);
  document.addEventListener('DOMContentLoaded', bindStylePurchase);
  document.addEventListener('shopify:section:load', bindStylePurchase);
  bindStylePurchase();

  function addItemsAndRedirect(productForm, items) {
    var addUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add';
    var cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';

    productForm.enableBtnLoading();
    productForm.toggleErrorMessage(true);

    fetch(addUrl + '.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    })
      .then(function(response) {
        return response.json().catch(function() {
          return {};
        }).then(function(data) {
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'カートへの追加に失敗しました。もう一度お試しください。');
          }
          window.location.assign(cartUrl);
        });
      })
      .catch(function(error) {
        productForm.handleErrorMessage(error.message);
        productForm.disableBtnLoading(false);
      });
  }

  document.addEventListener(
    'submit',
    function(event) {
      var form = event.target;
      if (!form || !form.matches('form[data-type="add-to-cart-form"]')) return;
      if (!form.closest('.as-unified-purchase')) return;
      if (form.closest('[data-style-purchase]')) syncStylePurchase();

      var config = getLaunchGiftConfig();
      var launchGiftActive = isLaunchGiftActive(config);
      var shouldRedirectToCart = form.dataset.cartBehavior === 'page';
      if (!launchGiftActive && !shouldRedirectToCart) return;

      var productForm = form.closest('product-form');
      if (!productForm || typeof productForm.add2cart !== 'function') return;

      var variantInput = form.querySelector('.as-unified-variant-id');
      var quantityInput = form.querySelector('.as-unified-quantity');
      var mainVariantId = variantInput && variantInput.value;
      var quantity = Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1);
      if (!mainVariantId) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      prepareProductFormUi(productForm, form);
      var items = [{ id: mainVariantId, quantity: String(quantity) }];
      if (launchGiftActive) {
        config.giftVariantIds.forEach(function(giftVariantId) {
          items.push({ id: giftVariantId, quantity: String(quantity) });
        });
      }

      if (shouldRedirectToCart) {
        addItemsAndRedirect(productForm, items);
      } else {
        productForm.add2cart(items);
      }
    },
    true
  );

  window.__asLaunchGiftGetConfig = getLaunchGiftConfig;
  window.__asLaunchGiftIsActive = isLaunchGiftActive;
  window.__asSyncLaunchGiftPurchaseButtons = syncLaunchGiftPurchaseButtons;

  function syncLaunchGiftPurchase() {
    syncLaunchGiftBundleState();
    syncLaunchGiftPurchaseButtons();
  }

  syncLaunchGiftPurchase();
  document.addEventListener('DOMContentLoaded', syncLaunchGiftPurchase);
  document.addEventListener('shopify:section:load', syncLaunchGiftPurchase);
  document.addEventListener('change', function(event) {
    if (!event.target.matches('.as-product-variant, .as-form-control-number')) return;
    window.setTimeout(syncLaunchGiftPurchaseButtons, 0);
  });
})();
